export default __webpack_public_path__ + "static/media/index_logo.e2d6f0f1.png";